import { render, staticRenderFns } from "./AuthorizedSigners.vue?vue&type=template&id=63fe605e"
import script from "./AuthorizedSigners.vue?vue&type=script&lang=ts"
export * from "./AuthorizedSigners.vue?vue&type=script&lang=ts"
import style0 from "./AuthorizedSigners.vue?vue&type=style&index=0&id=63fe605e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports